<template>
    <div class="doctorMenu">
        <div
            class="doctorMenuStatus"
            :class="{ 'doctorMenuStatusPublished' : menu.status === constDoctorMenus.published }">
            <span class="u-palt">{{ menu.status === constDoctorMenus.published ? '公開中' : '公開停止中' }}</span><!--
         --><span class="u-palt">&nbsp;{{ restrictReason(menu) }}</span>
        </div>

        <doctor-menu-info :menu="menu"/>

        <div class="d-flex justify-content-between align-items-center mt-4 pt-2">
            <div
                class="copyDeeplinkBtn"
                :class="{ 'copied' : isCopiedDeeplink }"
                @click="copyDeeplink">
                <div v-if="isCopiedDeeplink">
                    <b-icon-clipboard-check></b-icon-clipboard-check>
                    <span>コピーしました！</span>
                </div>
                <div v-else>
                    <b-icon-clipboard></b-icon-clipboard>
                    <span>URLをコピー</span>
                </div>
            </div>

            <div>
                <b-button
                    v-if="menu.disp_order !== 1"
                    variant="yokumiru-outline-gray"
                    class="ml-1 mr-1"
                    @click="updateDispOrder">
                    先頭へ移動
                </b-button>
                <b-button
                    v-if="menu.status === constDoctorMenus.published"
                    variant="yokumiru-gray"
                    class="ml-1 mr-1"
                    @click="showModalAdminToggleStatusDoctorMenu(menu)">
                    公開を停止する
                </b-button>
                <b-button
                    v-if="menu.status === constDoctorMenus.unpublished"
                    variant="success"
                    class="ml-1 mr-1"
                    @click="showModalAdminToggleStatusDoctorMenu(menu)">
                    公開する
                </b-button>
                <b-button
                    variant="yokumiru-blue"
                    class="ml-1 mr-1"
                    @click="showModalAdminEditDoctorMenu(menu)">
                    編集
                </b-button>
                <b-button
                    variant="danger"
                    class="ml-1 mr-1"
                    @click="showModalAdminDeleteDoctorMenu(menu)">
                    削除
                </b-button>
            </div>
        </div>
    </div>
</template>

<script>
    import constants from '../../constants'

    export default {
        props: {
            menu: {
                type: Object,
                required: true,
            },
        },

        data: function () {
            return {
                constDoctorMenus: constants.doctor_menus,
                isCopiedDeeplink: false,
            }
        },

        computed: {
            deeplinkUrl: function () {
                let url = `${location.protocol}//${location.host}/deeplink?action=reservation_menu_detail`
                url += `&medical_course_id=${this.menu.medical_course_id}`
                url += `&doctor_menu_id=${this.menu.id}`
                url += `&doctor_id=${this.menu.doctor_id}`

                return url
            },
        },

        methods: {
            /**
             * 公開制限理由を返す
             * @param {object} doctorMenu
             * @return {string}
             */
            restrictReason: function (doctorMenu) {
                if (doctorMenu.status === this.constDoctorMenus.published) {
                    return ''
                }

                if (doctorMenu.restrict_reason === 'DOCTOR_NOT_ACTIVE') {
                    return '（1ヶ月未ログイン）'
                }
                else if (doctorMenu.restrict_reason === 'DOCTOR_LOGIN') {
                    return '（未確認キャンセル）'
                }
                else if (doctorMenu.restrict_reason === 'DOCTOR_CANCEL_CONFIRMED') {
                    return '（確定後キャンセル）'
                }
                else if (doctorMenu.restrict_reason === 'DOCTOR_ABSENCE') {
                    return '（未入室終了）'
                }
                return ''
            },

            /**
             * 選択したメニューを先頭へ移動（表示順の更新）
             */
            updateDispOrder: function () {
                const endpoint = constants.admin.doctor_menus.endpoint.base

                axios.put(`${endpoint}/${this.menu.id}/order`)
                    .then(() => {
                        bus.$emit('fetch-doctor-menus')
                        bus.$emit('alert-success', 'メニューを先頭へ移動しました。')
                    })
                    .catch(() => {
                        bus.$emit('alert-danger', 'システムエラーが発生しました。')
                    })
            },

            /**
             * ディープリンクURLのコピー
             */
            copyDeeplink: function () {
                if (navigator.clipboard) {
                    navigator.clipboard.writeText(this.deeplinkUrl).then(() => {
                        this.isCopiedDeeplink = true
                        setTimeout(() => this.isCopiedDeeplink = false, 1500)
                    })
                }
            },

            /**
             * メニュー更新モーダル表示
             *
             * @param {object} doctorMenu
             */
            showModalAdminEditDoctorMenu: function (doctorMenu) {
                bus.$emit('open-modal-admin-edit-doctor-menu', doctorMenu)
            },

            /**
             * メニューステータス切替モーダル表示
             *
             * @param {object} doctorMenu
             */
            showModalAdminToggleStatusDoctorMenu: function (doctorMenu) {
                bus.$emit('open-modal-admin-toggle-status-doctor-menu', doctorMenu)
            },

            /**
             * メニュー削除モーダル表示
             *
             * @param {object} doctorMenu
             */
            showModalAdminDeleteDoctorMenu: function (doctorMenu) {
                bus.$emit('open-modal-admin-delete-doctor-menu', doctorMenu)
            },
        },
    }
</script>

<style lang="scss" scoped>
.doctorMenu {
    position: relative;
    display: inline-block;
    vertical-align: top;
    max-width: 620px;
    margin: 15px;
    padding: 25px;
    background-color: #f9f9f9;
    border: 1px solid #dee2e6;
    border-radius: 6px;

    @media screen and (max-width:768px) {
        width: auto;
        max-width: 620px;
        display: block;
    }
}

.doctorMenuStatus {
    position: absolute;
    right: 25px;
    top: 15px;
    color: #8694A9;
    font-weight: bold;

    span {
        &:nth-child(1) {
            font-size: 18px;
        }

        &:nth-child(2) {
            font-size: 13px;
        }
    }
}

.doctorMenuStatusPublished {
    color: #54A450;
}

.copyDeeplinkBtn {
    padding: 6px 12px;
    font-size: 13px;
    background: #efefef;
    border-radius: 15px;
    cursor: pointer;
    transition: background 0.2s ease-out;

    &:hover {
        background: #dcdcdc;
    }

    &.copied {
        background: #daead9;
        transition: none;

        > div {
            color: #54a450;
        }
    }
}
</style>
